import { movieApi, tvApi } from "api";
import React from "react";
import SearchPresenter from "./SearchPresenter";


export default class extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            movieResults: null,
            tvResults: null,
            searchTerm: "",
            error: null,
            loading: false
        }
    }
    
    //if we get input dann it works
    handleSubmit = (event) => {
        event.preventDefault();
        const { searchTerm}= this.state;
        if(searchTerm !== ""){
            this.searchByTerm();
        }
    }

    updateTerm = (event) => {
        const {target: {value}} = event;
        console.log(value);
        this.setState({
            searchTerm: value
        })
    }

    searchByTerm = async () => {
        const { searchTerm } = this.state;
        this.setState({loading: true});
        try{
            const {data: {results: movieResults}} = await movieApi.search(searchTerm);
            const {data: {results: tvResults}} = await tvApi.search(searchTerm);
            console.log(movieResults, tvResults);
            this.setState({
                movieResults,
                tvResults
            });
        } catch{
            this.setState({error: "can't find results"});
        } finally{
            setTimeout(() => {
                this.setState({
                    loading: false
    
                })
            }, 1500);
        }
    }
    render(){
        const {movieResults, tvResults, searchTerm, error, loading} = this.state;
        console.log(this.state);
        return(
            <SearchPresenter
            movieResults={movieResults}
            tvResults={tvResults}
            searchTerm={searchTerm}
            error={error} 
            loading={loading}
            handleSubmit={this.handleSubmit}
            updateTerm={this.updateTerm}
            />
        )
    }
}